import React from "react";
//import { Col, Button } from "react-bootstrap";

import 'animate.css';
import './home.css';
import '../../App.css'
import mainImg from '../../assets/main devloper.png';
import Typing from 'react-typing-effect';

import { motion } from 'framer-motion';


function Home() {

  return (

    <div>

      <section className="background" id="home">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xs-12 col-md-6 col-xl-7  text-white" >


              <motion.div
              initial={{ opacity: 0, x: -100 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 , ease: "easeInOut" ,delay: 0.2 }} >
                <span className="fs-2 ">Welcome to My Portfolio</span>
                <h1>{`Hi! I'm weam ibrahim `} <p className="text-rotate " ><span className="wrap">

                <Typing
                        text={[
                          "Fullstack Developer",
                          "Frontend Developer",
                          "Backend Developer",
                        ]}
                        speed={60}
                        eraseSpeed={60}
                        typingDelay={0}
                        eraseDelay={1000}
                        loop
                      />






                </span></p></h1>
                <p className="fs-4 ">

                  Junior Web Developer with a passion for web development, eager to contribute innovative solutions and
                  continually learn in a challenging environment.</p>

              </motion.div>

            </div>
            <div className="col-xs-12 col-md-6 col-xl-5">


              <motion.div  initial={{ opacity: 0, x: 100 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 , ease: "easeInOut" ,delay: 0.2 }}>
                <img src={mainImg} className="img-fluid" alt="Header Img" />
              </motion.div >

            </div>
          </div>
        </div>


      </section>

    </div>
  );
}

export default Home;
